
	import {
		Vue,
		Component,
		Emit
	} from "vue-property-decorator";
	import empty from "../../components/empty.vue";
	@Component({
		components: {empty},
	})
	//export default class "组件名" extends Vue
	export default class courseCenter extends Vue {
		formInline: object = {};
		courseList:object[] = [
			{
				type:"通识课",
				stateDesc:"待发布",
				stateCode:"1",
				name:"python 编程基础",
				period:"小学、初中、高中"
			},{
				type:"通识课2",
				stateDesc:"已发布",
				stateCode:"1",
				name:"python 编程基础2",
				period:"小学、初中、高中2"
			},{
				type:"通识课3",
				stateDesc:"待审核",
				stateCode:"1",
				name:"python 编程基础3",
				period:"小学、初中、高中3"
			}
		];
		user: string = "";
		currentpPage: number = 5;
		handleChange() {
			console.log('切换属性');
		};


		mounted() {

		};

		created() {
			// this.courseList.length = 8;
		};
	}
